import React, { Component } from 'react'
import styled from 'styled-components'
import onClickOutside from 'react-onclickoutside'
import { device } from '../../../utils/helpers'

const Outer = styled.div`
  font-size: 18px;
  color: #4d4d4d;
  text-transform: uppercase;
  font-family: 'BarlowSemiBold';
  margin-top: ${props => props.form && '5px'};
  padding: ${props => props.padding};

  @media ${device.tablet} {
    width: 100%;
  }
`

const Title = styled.p`
  padding-bottom: 8px;

  @media ${device.laptop} {
    font-size: 16px;
  }

  @media ${device.laptopL} {
    font-size: inherit;
  }
`

const Wrapper = styled.div`
  width: 192px;
  height: ${props => props.form ? '60px' : '65px'};
  ${'' /* z-index: 1; */}
  position: relative;
  background-color: ${props => props.form ? '#f3f3f3' : '#e2e2e2'};

  ${'' /* @media ${device.laptop} {
    width: 125px;
  }

  @media ${device.laptopM} {
    width: 140px;
  } */}

  @media ${device.tablet} {
    width: 100%;
  }

  @media ${device.laptop} {
    ${''}
    width: 100%;
  }
`

const Header = styled.div`
  height: ${props => props.form ? '60px' : '65px'};
  display: flex;
  align-items: center;
  ${''}
  padding: 0 15px;
  justify-content: space-between;
`

const Selection = styled.div`
  font-size: 18px
`

const List = styled.ul`
  list-style: none;
  background-color: white;
  position: absolute;
  top: ${props => props.form ? '60px' : '65px'};
  left: 0;
  bottom: 0;
  right: 0;
  height: 100px;
  overflow: auto;
  z-index: 1;
`

const Item = styled.li`
  padding: 5px 15px;
  z-index: 10000;
  background-color: ${props => props.theme.color.bgLight};
  cursor: pointer;

  &:hover {
    background-color: ${props => props.theme.color.bgMedium};
  }
`

const ArrowDown = styled.i`
  border: solid black;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 3px;
  margin-bottom: 3px;
  transform: rotate(45deg);
`

class Dropdown extends Component {
  constructor (props) {
    super(props)
    console.log(props.default)
    this.state = {
      listOpen: false,
      title: this.props.title,
      selected: props.default || {}
    }
  }

  // Close Dropdown when clicked outside
  handleClickOutside () {
    this.setState({ listOpen: false })
  }

  // Open/close dropdown list
  toggleList () {
    this.setState({ listOpen: !this.state.listOpen })
  }

  // Sets the selection
  handleSelection (data) {
    this.setState({ selected: data, listOpen: false })
    this.props.selected(data)
  }

  render () {
    const { list, form, padding } = this.props
    const { title, listOpen, selected } = this.state
    return (
      <Outer form={form} padding={padding}>
        <Title>{title}</Title>
        <Wrapper form={form}>
          <Header onClick={this.toggleList.bind(this)} form={form}>
            <Selection>{selected.id ? selected.name : ''}</Selection>
            <ArrowDown />
          </Header>
          {listOpen && <List form={form}>
            {list.map(item => {
              return (
                <Item key={item.id} onClick={this.handleSelection.bind(this, item)}>{item.name}</Item>
              )
            })}
          </List>}
        </Wrapper>
      </Outer>
    )
  }
}

export default onClickOutside(Dropdown)



// WEBPACK FOOTER //
// ./src/components/UI/Form/Select.js